.root {
  align-items: center;
  display: inline-flex;
  gap: 4px;
}

.button {
  align-items: center;
  background: var(--color-secondary, #f3f4f6);
  border: none;
  border-radius: 8px;
  color: var(--color-muted, #6b7280);
  cursor: pointer;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  padding: 0;
  transition: background 0.15s, color 0.15s;
  width: 28px;
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

// Attention (amber). Inactive: keep tinted background + amber icon so the
// affordance is visible without hovering. Active: solid amber fill.
.button-is-attention {
  background: rgba(245, 158, 11, 0.15);
  color: #b45309;
}

.button-is-attention:hover:not(:disabled) {
  background: rgba(245, 158, 11, 0.28);
  color: #92400e;
}

.button-is-attention-active {
  background: #d97706;
  color: #ffffff;
}

.button-is-attention-active:hover:not(:disabled) {
  background: #b45309;
}

// Urgent (red). Same approach — visible tint + red icon when inactive.
.button-is-urgent {
  background: rgba(239, 68, 68, 0.15);
  color: #b91c1c;
}

.button-is-urgent:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.28);
  color: #991b1b;
}

.button-is-urgent-active {
  background: #dc2626;
  color: #ffffff;
}

.button-is-urgent-active:hover:not(:disabled) {
  background: #b91c1c;
}
